(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    const backToTopButton = document.getElementById('backToTop');

  window.onscroll = function () {
    if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
      backToTopButton.classList.add('active');
    } else {
      backToTopButton.classList.remove('active');
    }
  };

  backToTopButton.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    document.querySelector('.js-sticky-add-button').addEventListener('click', () => {
    document.querySelector('.add-to-cart-button').click();
  });

  const target = document.querySelector('.buy-buttons-block product-form-component');
  const hiddenElement = document.querySelector('.js-sticky-add-to-cart');

  // Define your media query
  const mediaQuery = window.matchMedia('(max-width: 750px)');

  let observer;

  function handleIntersection(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        hiddenElement.classList.add('visible');
      } else {
        hiddenElement.classList.remove('visible');
      }
    });
  }

  function initObserver() {
    if (mediaQuery.matches) {
      observer = new IntersectionObserver(handleIntersection, {
        threshold: 0,
      });
      observer.observe(target);
    } else {
      hiddenElement.classList.remove('visible');
      if (observer) observer.disconnect();
    }
  }

  // Initialize on load
  initObserver();

  mediaQuery.addEventListener('change', initObserver);
  } catch(e) { console.error(e); }
})();

})();
